import type { PlanDuration } from '@vy/types';
import { UNLIMITED_DURATION } from '@vy/types';
import { getPlanDurationValues } from './get-plan-duration-values';

export function mapPlanDurationToLabel() {
  const multipleMonthsArray = Array.from({ length: 10 }, (_, index) => index + 2);
  const basePlanDurationLabels: Record<PlanDuration, string> = {
    1: '1 month',
    12: '1 year',
    18: '18 months',
    24: '24 months',
    [UNLIMITED_DURATION]: 'Evergreen',
  };

  return multipleMonthsArray.reduce((labeledDurations, i) => {
    return {
      ...labeledDurations,
      [i]: `${i} months`,
    };
  }, basePlanDurationLabels);
}

export function getPlanDurationLabel(duration: PlanDuration): string {
  return getPlanDurationValues().find(({ value }) => value === duration)?.label ?? `${duration} months`;
}
